import { render, staticRenderFns } from "./NotificationModalPopout.vue?vue&type=template&id=740e1654&scoped=true"
import script from "./NotificationModalPopout.vue?vue&type=script&lang=ts"
export * from "./NotificationModalPopout.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModalPopout.vue?vue&type=style&index=0&id=740e1654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e1654",
  null
  
)

export default component.exports